import React, { PropsWithChildren, ReactElement } from 'react';
import classnames from 'classnames';
import { SIZES, WEIGHTS, HEADING_LEVELS } from '../../constants/font';

type TextSizes = typeof SIZES[number];
type TextWeights = typeof WEIGHTS[number];
type HeadingLevels = typeof HEADING_LEVELS[number];

export type HeadingProps = PropsWithChildren<{
  className?: string;
  level: HeadingLevels;
  size?: TextSizes;
  weight?: TextWeights;
  align?: 'left' | 'center' | 'right';
}>;

export const DEFAULT_PROPS: Partial<HeadingProps> = {
  align: 'center',
  size: '64',
  weight: '300',
};

export function Heading({
  level: HeadingLevel,
  children,
  className = '',
  size = DEFAULT_PROPS.size,
  weight = DEFAULT_PROPS.weight,
  align = DEFAULT_PROPS.align,
}: HeadingProps): ReactElement {
  const classes = classnames(
    `text-size-${size} text-weight-${weight} text-${align}`,
    {
      [className]: !!className,
    },
  );

  return <HeadingLevel className={classes}>{children}</HeadingLevel>;
}
